/**
 * Canonical company / legal-entity details for the frontend.
 *
 * The site is branded **lovinahome** but the underlying legal entity that
 * contracts with customers, charges them, files Irish Revenue and is named
 * on VAT invoices is **Lovinabargain Ltd**. Mirror any change in
 * /app/backend/company.py.
 */

export const LEGAL_NAME = 'Lovinabargain Ltd';
export const BRAND_NAME = 'lovinahome';
export const SITE_DOMAIN = 'lovinahome.com';

export const CRO_NUMBER = '656000';
export const VAT_NUMBER = 'IE3672167TH';

export const REGISTERED_OFFICE = {
  line1: 'Unit 4 Ballinahinch Upper',
  line2: 'Newtownmountkennedy',
  county: 'Co. Wicklow',
  country: 'Ireland',
};

export const registeredOfficeOneLine = () =>
  `${REGISTERED_OFFICE.line1}, ${REGISTERED_OFFICE.line2}, ${REGISTERED_OFFICE.county}, ${REGISTERED_OFFICE.country}`;

export const LEGAL_FOOTER_LINE =
  `${LEGAL_NAME} trading as ${BRAND_NAME}. Registered in Ireland · ` +
  `CRO ${CRO_NUMBER} · VAT ${VAT_NUMBER} · ${registeredOfficeOneLine()}.`;

export const SUPPORT_EMAIL = 'hello@lovinahome.com';
export const BILLING_EMAIL = 'billing@lovinahome.com';
export const LEGAL_EMAIL = 'legal@lovinahome.com';
export const PRIVACY_EMAIL = 'privacy@lovinahome.com';
